/** The URL segment that marks a bot-protected distribution. */
export const PROTECTED_PATH_SEGMENT = 'protected'

/** The navigation path prefix for a bot-protected distribution. */
export const PROTECTED_PATH_PREFIX = `/${PROTECTED_PATH_SEGMENT}`

const PROTECTED_MOUNT_PATTERN = new RegExp(`^/(distributor|tracker)/(?!${PROTECTED_PATH_SEGMENT}/)`)

/**
 * Rewrites a distributor or tracker request path onto its `/protected` mount.
 *
 * A protected navigation has to call the protected mount for every request it makes.
 *
 * Idempotent — an already-protected path is returned unchanged.
 *
 * @example
 * toProtectedMount('/tracker/tracker.Tracker/Event')
 * // '/tracker/protected/tracker.Tracker/Event'
 */
export const toProtectedMount = (url: string): string =>
  url.replace(PROTECTED_MOUNT_PATTERN, `/$1${PROTECTED_PATH_PREFIX}/`)
